import React from 'react';
import { RoutingDataContext } from './context';

export const useRoutingData = () => React.useContext(RoutingDataContext).routingData;

export const useSetRoutingData = () => React.useContext(RoutingDataContext).setRoutingData;

export const useSetInitialQueryParams = () => {
  const setRoutingData = useSetRoutingData();

  return (query: Record<string, any>) => {
    const { logout, to, treset, tt, username } = query;
    setRoutingData((current) => ({
      ...current,
      logoutParam: logout,
      redirectParam: getRidrectParam(to),
      passwordResetTokenParam: treset,
      authTokenParam: tt,
      usernameParam: username || null,
    }));
  };
};

export const getRidrectParam = (redirectParam: string): string => {
  const whitelistRegex = new RegExp(
    '^https?://([a-zA-Z0-9-_]+[.])*(?:' + 'crashplan|crashplanpro|code42' + ')\\.com(:[0-9]*)?(/.*)?$',
  );
  redirectParam = redirectParam || '//';
  return redirectParam.indexOf('//') === -1 || whitelistRegex.test(redirectParam) ? redirectParam : null;
};
